import React, { useState, useEffect } from 'react';
import {
  getChannelById,
  getCostCenterById,
  getCostCenters,
  getOptionsForBusinessArea,
  getRegionById,
  getRegions,
  isChanelSameBusinessArea,
  mapChanneldata,
  mapCostCenterData,
  mapRegionData,
} from './Functions';
import { useGlobalContext } from '../../../../../../context/GlobalContext';
import { ServiceClient } from '../../../../../../Services/ServiceClient';
import SearchableDropdownInput from '../../../../../../Elements/SearchableDropdownInput';
import { formatMessage } from '../../../../../../Localization/formatMessage';
import Messages from '../../../../../../Localization/Messages';
import Select from '../../../../../../Elements/ids/InputElements/Select';
import { getBusinessAreaByChannel } from '../../../../../../Helpers/AgentHelper';
import { PresentationMode } from '../../../../../../Enums/PresentationMode';
import LoaderComponent from '../../../../../../Elements/ids/Loader';

const ChannelDataHandler = ({ editedAgent, setEditedAgent, teamCountry, setModalMode, modalMode }) => {
  const { businessArea } = useGlobalContext();

  const [allChannels, setAllChannels] = useState([]);
  const [selectedChannelId, setSelectedChannelId] = useState(editedAgent.channel?.id);
  const [selectedRegionId, setSelectedRegionId] = useState(editedAgent.region?.id);
  const [selectedCostCenterId, setSelectedCostCenterId] = useState(editedAgent.costCenterId);
  const [costCenterList, setCostCenterList] = useState([]);
  const [regionList, setRegionList] = useState([]);
  const [channelList, setChannelList] = useState([]);
  const [selectedBusinessArea, setSelectedBusinessArea] = useState(
    editedAgent.channel?.id ? getBusinessAreaByChannel(editedAgent.channel) : businessArea
  );

  useEffect(() => {
    const previousModalMode = modalMode;
    setModalMode(PresentationMode.Loading);

    ServiceClient.getChannels(data => {
      setModalMode(previousModalMode);
      setAllChannels(data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const tempChannels = [];
    const tempCostCenters = [];
    const tempRegions = [];

    allChannels
      .filter(channel => isChanelSameBusinessArea(channel, selectedBusinessArea))
      .forEach(channel =>
        channel.regions.forEach(region => {
          if (region.legalUnitName === teamCountry.name && region.costCenters.length > 0) {
            if (!tempChannels.some(x => x.id === channel.id)) {
              tempChannels.push(mapChanneldata(channel));
            }

            tempRegions.push(mapRegionData(region, channel));

            region.costCenters.forEach(costCenter => {
              tempCostCenters.push(mapCostCenterData(costCenter, region, channel));
            });
          }
        })
      );

    setCostCenterList(tempCostCenters);
    setRegionList(tempRegions);
    setChannelList(tempChannels);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allChannels, selectedBusinessArea]);

  const onChannelChange = id => {
    const result = channelList.find(channel => channel.id === id);
    setSelectedChannelId(result.id);
    setSelectedRegionId(null);
    setSelectedCostCenterId(null);
    setEditedAgent({ ...editedAgent, costCenterId: null });
  };

  const onRegionChange = id => {
    const result = regionList.find(region => region.id === id);
    setSelectedChannelId(result.channelId);
    setSelectedRegionId(result.id);
    setSelectedCostCenterId(null);
    setEditedAgent({ ...editedAgent, costCenterId: null });
  };

  const onCostCenterChange = id => {
    const result = costCenterList.find(costCenter => costCenter.id === id);
    setSelectedChannelId(result.channelId);
    setSelectedRegionId(result.regionId);
    setSelectedCostCenterId(result.id);
    setEditedAgent({ ...editedAgent, costCenterId: result.id });
  };

  return (
    <>
      {modalMode === PresentationMode.Loading ? (
        <LoaderComponent />
      ) : (
        <>
          <Select
            label={formatMessage(Messages.customHeader_settings_businessArea)}
            defaultValue={selectedBusinessArea}
            options={getOptionsForBusinessArea()}
            onChange={e => {
              setSelectedBusinessArea(e.target.value);
              setSelectedChannelId(null);
              setSelectedRegionId(null);
              setSelectedCostCenterId(null);
              setEditedAgent({ ...editedAgent, costCenterId: null });
            }}
          />
          <SearchableDropdownInput
            items={channelList}
            onChange={onChannelChange}
            selectedItem={getChannelById(selectedChannelId, channelList)}
            label={formatMessage(Messages.agentInfo_channel)}
          />
          <SearchableDropdownInput
            items={getRegions(regionList, selectedChannelId)}
            onChange={onRegionChange}
            selectedItem={getRegionById(selectedRegionId, regionList)}
            label={formatMessage(Messages.agentInfo_region)}
          />
          <SearchableDropdownInput
            items={getCostCenters(costCenterList, selectedRegionId, selectedChannelId)}
            onChange={onCostCenterChange}
            selectedItem={getCostCenterById(selectedCostCenterId, costCenterList)}
            isMandatory={true}
            label={formatMessage(Messages.agentInfo_costCenter)}
          />
        </>
      )}
    </>
  );
};

export default ChannelDataHandler;
